const Permissions = {
    manageUsers: 'manage-users',
    manageTeams: 'manage-teams',
    manageAuthenticationProviders: 'manage-authentication-providers',
    manageClients: 'manage-clients',
    manageSystemSettings: 'manage-system-settings',
    manageRoles: 'manage-roles',
    allowAll: 'allow-all'
};

export default Permissions;
